import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=273e795f&scoped=true"
import script from "./SplashScreen.vue?vue&type=script&lang=ts"
export * from "./SplashScreen.vue?vue&type=script&lang=ts"
import style0 from "./SplashScreen.vue?vue&type=style&index=0&id=273e795f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273e795f",
  null
  
)

export default component.exports